module.exports = "data:image/gif;base64,R0lGODlhDAAMAJECAP////8AAP///wAAACH5BAEAAAIALAAAAAAMAAwAAAIeRI5pwO1nwpMQMQujim3za4HgVmUYJXWowxpCAksFADs="